var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg08Nougyou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#FD8039;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_3_",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,4.6c0.8-0.2,1.4-0.7,1.7-1.4c-0.6-0.5-1.4-0.7-2.2-0.5c-0.8,0.2-1.4,0.7-1.7,1.4C16.4,4.6,17.2,4.8,18,4.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.1,3.6c0.8-0.2,1.4-0.7,1.7-1.4c-0.6-0.5-1.4-0.7-2.2-0.5c-0.8,0.2-1.4,0.7-1.7,1.4 C20.5,3.6,21.3,3.8,22.1,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.3,6.4c0.7,0.2,1.6,0.2,2.2-0.3c0.7-0.4,1-1.2,1.1-1.9C14.9,4,14.1,4,13.4,4.5C12.8,4.9,12.4,5.6,12.3,6.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,8.5c0.8-0.2,1.4-0.8,1.7-1.5c-0.6-0.5-1.4-0.7-2.2-0.5c-0.8,0.2-1.4,0.8-1.7,1.5 C16.2,8.5,17,8.7,17.7,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.4,10.1c0.7-0.5,1-1.2,1.1-2c-0.8-0.2-1.6-0.1-2.2,0.3s-1,1.2-1.1,2C12.9,10.7,13.7,10.6,14.4,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,11.6c-0.5,0.7-0.5,1.5-0.3,2.2c0.8-0.1,1.5-0.4,2-1.1s0.5-1.5,0.3-2.2C11.3,10.6,10.6,10.9,10.1,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.4,8c-0.8,0.1-1.4,0.6-1.8,1.3c0.6,0.5,1.3,0.8,2.1,0.7s1.4-0.6,1.8-1.3C26,8.1,25.2,7.9,24.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,11.1c0.7-0.4,1.1-1.1,1.3-1.8C21.8,9,21,9,20.3,9.4c-0.7,0.4-1.1,1.1-1.3,1.8 C19.7,11.5,20.5,11.5,21.2,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,13.5c0.5-0.6,0.7-1.4,0.6-2.2c-0.8,0-1.5,0.2-2.1,0.8c-0.5,0.6-0.7,1.4-0.6,2.2c0,0,0,0,0,0 c-4.4,3-7.8,6.3-10.5,9.4c1-3.3,3-6.8,5.9-9.9c-2.1,1.7-3.9,3.5-5.4,5.3c0.7-3.2,2.1-6.4,4.1-9.4c0.6-0.1,1.1-0.4,1.5-0.9 c0.5-0.6,0.6-1.4,0.4-2.2c-0.8,0-1.5,0.4-2,1C9.8,8.2,9.7,9,9.9,9.7c0.1,0,0.2,0,0.3,0C4.7,15.6,1.6,22.2,1,28c0,0,0,0,0,0 c0,0,0,0,0,0c0.6,0,1.1,0,1.7,0c0.8,0,1.5,0,2.3,0c0.3,0,0.6,0,0.9,0c0.7,0,1.3,0,2,0c1-4.4,3.8-9.3,8.5-13.7 C17.1,14.3,17.8,14,18.3,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.2,14.8c-0.5,0.6-0.7,1.4-0.6,2.2c0.8,0,1.5-0.2,2.1-0.8c0.5-0.6,0.7-1.4,0.6-2.2 C18.5,14,17.8,14.2,17.2,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.3,4.2c0.6-0.5,1-1.2,1-2c-0.8-0.2-1.6-0.1-2.2,0.4c-0.6,0.5-1,1.2-1,2C10.9,4.8,11.7,4.7,12.3,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,7c0.4-0.7,0.5-1.5,0.2-2.2C9.2,4.8,8.5,5.2,8.1,5.9S7.6,7.3,7.8,8.1C8.6,8,9.3,7.6,9.8,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,10.4c0.2-0.8,0-1.6-0.5-2.2C7.1,8.6,6.6,9.2,6.4,9.9s0,1.6,0.5,2.2C7.6,11.8,8.2,11.2,8.3,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.6,13.1c0.4-0.7,0.4-1.5,0.2-2.2c-0.8,0.1-1.5,0.5-1.9,1.2c-0.4,0.7-0.4,1.5-0.2,2.2 C14.5,14.2,15.2,13.8,15.6,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.4,12c-0.6,0.5-1,1.2-1,2c0.8,0.2,1.6,0.1,2.2-0.4c0.6-0.5,1-1.2,1-2C21.8,11.4,21,11.5,20.4,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08Nougyou);
export default __webpack_public_path__ + "static/media/08_nougyou.e5120755730b8729b9d13b5ddb0fd6a9.svg";
export { ForwardRef as ReactComponent };